/*
 * ErrorListTypes  types
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ICompileError, IDocumentError, IRuntimeError } from "@adapptio/lib-blueprint";
import { IErrorListCategoryTitleProps } from "./ErrorListCategoryTitle";
import { IErrorListItemProps } from "./ErrorListItem";

export enum ERROR_LIST_CATEGORY {
	ALL = "all",
	PARSE_ERRORS = "parseErrors",
	RUNTIME_ERRORS = "runtimeErrors"
}

export interface IErrorListGroup {
	documentUri?: string;
	parseErrors?: IDocumentError[];
	compileErrors?: ICompileError[];
	runtimeErrors?: IRuntimeError[];
}

export enum ERROR_LIST_ITEM_DATA_TYPE {
	CATEGORY_TITLE,
	ERROR
}

export interface IErrorListItemCategoryData {
	type: ERROR_LIST_ITEM_DATA_TYPE.CATEGORY_TITLE;
	value: IErrorListCategoryTitleProps;
}

export interface IErrorListItemErrorData {
	type: ERROR_LIST_ITEM_DATA_TYPE.ERROR;
	value: IErrorListItemProps;
}

export type IErrorListItemData = IErrorListItemCategoryData | IErrorListItemErrorData;

export type OnErrorItemClick<T extends ICompileError | IRuntimeError | IDocumentError> = (
	error: T,
	errorGroup: IErrorListGroup
) => void;
